import { OrderingProviderFieldsFragment } from 'src/types';

function normalizeString(val: unknown): string {
  if (val == null) return '';
  return String(val).trim();
}

function normalizeEmail(val: unknown): string {
  return normalizeString(val).toLowerCase();
}

function normalizeBoolean(val: unknown): boolean {
  return val === true;
}

/**
 * Snapshot of ordering-provider fields that can be edited in the OP form and
 * affect a revise-report submission even when the provider ID is unchanged.
 */
function getOrderingProviderComparableFields(
  provider: OrderingProviderFieldsFragment | null,
): Record<string, string | boolean> {
  return {
    orderingPhysicianFirstName: normalizeString(
      provider?.orderingPhysician?.firstName,
    ),
    orderingPhysicianLastName: normalizeString(
      provider?.orderingPhysician?.lastName,
    ),
    orderingPhysicianNpi: normalizeString(provider?.orderingPhysician?.npi),
    orderingPhysicianEmail: normalizeEmail(provider?.orderingPhysician?.email),
    siteName: normalizeString(provider?.siteName),
    receiveReportsByFax: normalizeBoolean(provider?.receiveReportsByFax),
    siteFaxNumber: normalizeString(provider?.siteFaxNumber),
    siteFaxRegionCode: normalizeString(provider?.siteFaxRegionCode),
  };
}

/**
 * Returns true when the selected ordering provider differs from the initial
 * provider on any editable field (e.g. physician name), even if the ID is the same.
 */
export function hasOrderingProviderChanges(
  current: OrderingProviderFieldsFragment | null,
  initial: OrderingProviderFieldsFragment | null,
): boolean {
  const currentFields = getOrderingProviderComparableFields(current);
  const initialFields = getOrderingProviderComparableFields(initial);

  return Object.keys(currentFields).some(
    (key) => currentFields[key] !== initialFields[key],
  );
}
